import React from 'react';
import {ChargeContainer} from '../../Containers/OrderContainer';

const ChargeDetails = (props) => {
	return (
		<ChargeContainer />
	);
}

export default ChargeDetails;